import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { DefaultCheckbox, DefaultSwitch } from 'services/UIUtils';
import PerformanceUtils from 'services/PerformanceUtils';
import DefaultButton from 'components/Utils/NewDefaultButton';
import DefaultTextField from 'components/Utils/DefaultTextField';
import ToggleSwitch from 'components/Utils/ToggleSwitch';
import { UserRoleEnum } from 'generated/api';

const EditFavorites = (props) => {
  let [favorites, setFavorites] = useState(props.favorites);
  let [filterText, setFilterText] = useState('');

  function onSelect(id, value) {
    let newFavorites = [...favorites];
    if (value) newFavorites = [...newFavorites, id];
    else newFavorites = newFavorites.filter((currentId) => currentId !== id);
    setFavorites(newFavorites);
  }

  const filteredTemplates = useMemo(() => {
    return PerformanceUtils.sortBy(props.templates, ['category_id'], false).filter((template) => {
      const category = props.templateCategories.find(
        (category) => template.category_id === category.id,
      );
      const categoryName = category ? category.name : '';
      const searchText = `${categoryName} ${template.description}`.toLowerCase();
      return searchText.includes(filterText.toLowerCase());
    });
  }, [props.templates, props.templateCategories, filterText]);

  return (
    <div className="favorites-wrapper">
      <DefaultTextField
        name="filter"
        placeholder="Filter templates..."
        value={filterText}
        onChange={(e) => setFilterText(e.target.value)}
      />
      <div className="list-wrapper">
        <ul className="scroll-list">
          {filteredTemplates.map((template) => {
            const isChecked = favorites.includes(template.id);

            const category = props.templateCategories.find(
              (category) => template.category_id === category.id,
            );

            const categoryName = category ? category.name + ' - ' : '';

            return (
              <li key={template.id} style={{ listStyleType: 'none' }}>
                <DefaultSwitch
                  name="template"
                  onChange={(event, value) => {
                    onSelect(template.id, value);
                  }}
                  label={`${categoryName} ${template.description}`}
                  reversed={true}
                  padded={false}
                  checked={isChecked}
                />
              </li>
            );
          })}
        </ul>
      </div>
      <div className="button-wrapper">
        <DefaultButton
          name="Save Favorites"
          className="blue"
          style={{ width: '250px', margin: 'auto', display: 'block' }}
          onClick={() => props.onSave(favorites)}
        />
      </div>
    </div>
  );
};

EditFavorites.propTypes = {
  templates: PropTypes.array,
  templateCategories: PropTypes.array,
  favorites: PropTypes.array,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};

export default EditFavorites;
